import useMedia from 'use-media';

import { theme } from '@notino/react-styleguide';

export function isDesktop() {
  return window.matchMedia(`(min-width: ${theme.breakpoints.md}rem)`).matches;
}

export const useIsDesktop = ({
  isNewPdDesign,
  defaultState,
}: {
  isNewPdDesign?: boolean;
  defaultState?: boolean;
} = {}) =>
  useMedia(
    isNewPdDesign
      ? `(min-width: ${theme.breakpoints.lg}rem)`
      : `(min-width: ${theme.breakpoints.md}rem)`,
    defaultState
  );
